import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoginService} from '../login-page/services/login.service';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {BaseDatabaseService} from '../shared/services/databaseServices/BaseDatabaseService';
import {MenuService} from '../shared/services/menuService/menu.service';
import {RoleGuard} from '../shared/guards/Role/role.guard';

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.css']
})
export class AdminPageComponent extends BaseDatabaseService implements OnInit, OnDestroy {

  opened = true;
  showItem = [];
  interval;

  menuItems = [
    { name: 'adminPage.nav.dashboard', link: '/admin', roles: ['admin', 'organizator']},
    { name: 'adminPage.nav.racer', link: '/admin/racers', roles: ['admin', 'organizator']},
    { name: 'adminPage.nav.races', link: '/admin/races', roles: ['admin'] },

    { name: 'adminPage.nav.settings', link: '/admin/settings', roles: ['admin'] }
  ];


  constructor(public loginService: LoginService,
              private router: Router,
              private menuService: MenuService) {
    super();
  }

  ngOnInit() {
    this.interval = setInterval( () => {
      this.showItem = this.menuItems.map(item => {
        return this.showItem[item.link] = item.roles.indexOf(this.loginService.role) !== -1;
      });
    }, 1000 );
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }


  logout() {
    this.loginService.destroyToken();
  }

  close() {
    if(window.innerWidth <= 600){
      this.menuService.toggleMenu();
    }
  }

  isOpen(){
    return this.menuService.toggle;
  }

}
